module.exports = __webpack_public_path__ + "static/media/css.8c1ae41d.png";